/* ============================================================
   EV Guards - protecciones de compra (sin apps)
   1) Personalización obligatoria del set de pesas MiniGymRats en
      todos los caminos de alta en carrito.
   2) Lista de favoritos: los productos con varias variantes no se
      añaden "a ciegas" con la primera variante; se abre la ficha.
   ============================================================ */
(function () {
  'use strict';

  /* --- Personalización obligatoria (MiniGymRats) ---
     La ficha del set de pesas tiene un campo obligatorio, pero hay otros
     caminos para añadir al carrito sin pasar por él: la barra fija inferior
     de la ficha, el "añadir rápido" y la vista rápida de las cards, y el
     botón de la lista de favoritos. Este guard intercepta cualquier alta en
     el carrito: si la variante es de un producto personalizable y no lleva
     la propiedad, cancela y lleva al cliente al campo de la ficha.
     Para añadir otro producto personalizable: añadir su handle a la lista. */
  var PERS_HANDLES = ['set-de-pesas-para-ninos-personalizable'];
  var PERS_PROP = 'Personalización barra';
  var persVariants = {};
  PERS_HANDLES.forEach(function (h) {
    fetch('/products/' + h + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) p.variants.forEach(function (v) { persVariants[v.id] = h; }); })
      .catch(function () {});
  });
  function persHandleIfMissing(id, prop) {
    var h = persVariants[Number(id)];
    if (!h) return null;
    return (prop && String(prop).trim()) ? null : h;
  }
  function missingFromBody(body) {
    var key = 'properties[' + PERS_PROP + ']';
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return persHandleIfMissing(body.get('id'), body.get(key));
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return persHandleIfMissing(body.get('id'), body.get(key));
    }
    if (typeof body === 'string') {
      var json = null;
      try { json = JSON.parse(body); } catch (e) {}
      if (json) {
        var items = json.items || [json];
        for (var i = 0; i < items.length; i++) {
          var it = items[i] || {};
          var hit = persHandleIfMissing(it.id, it.properties && it.properties[PERS_PROP]);
          if (hit) return hit;
        }
        return null;
      }
      var q = new URLSearchParams(body);
      return persHandleIfMissing(q.get('id'), q.get(key));
    }
    return null;
  }
  function goPersonalize(handle) {
    if (window.location.pathname.indexOf('/products/' + handle) !== -1) {
      var input = document.querySelector('[name="properties[' + PERS_PROP + ']"]');
      if (input) {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { input.focus(); if (input.reportValidity) input.reportValidity(); }, 400);
        return;
      }
    }
    window.location.href = '/products/' + handle + '#personaliza';
  }
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add/.test(url) && init && init.body) {
          var missing = missingFromBody(init.body);
          if (missing) {
            goPersonalize(missing);
            return Promise.reject(new Error('Falta la personalización de la barra'));
          }
        }
      } catch (e) {}
      return nativeFetch.apply(this, arguments);
    };
  }
  /* Botones "añadir rápido" de las cards (data-variant-id) */
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-variant-id]');
    if (!el) return;
    var h = persVariants[Number(el.getAttribute('data-variant-id'))];
    if (!h) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    goPersonalize(h);
  }, true);
  /* Envíos por formulario clásico (Shopify.postLink en la página de carrito) */
  function wrapPostLink() {
    if (!window.Shopify || typeof window.Shopify.postLink !== 'function' || window.Shopify.postLink.__evWrapped) return;
    var original = window.Shopify.postLink;
    window.Shopify.postLink = function (path, options) {
      try {
        var params = (options && options.parameters) || {};
        if (/\/cart\/add/.test(path)) {
          var h = persHandleIfMissing(params.id, params['properties[' + PERS_PROP + ']']);
          if (h) { goPersonalize(h); return; }
        }
      } catch (e) {}
      return original.apply(this, arguments);
    };
    window.Shopify.postLink.__evWrapped = true;
  }

  /* --- Lista de favoritos: productos con opciones --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ev-wl-add[data-variant]');
    if (!btn) return;
    var card = btn.closest('.ev-wl-card');
    var link = card && card.querySelector('a.ev-wl-title');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var url = link.getAttribute('href');
    btn.disabled = true;
    fetch(url.split('?')[0] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var personalizable = (p.tags || []).indexOf('personalizable') !== -1;
        if (p.variants.length > 1 || personalizable) { window.location.href = url; return; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: p.variants[0].id, quantity: 1 })
        }).then(function () { window.location.href = '/cart'; });
      })
      .catch(function () { window.location.href = url; });
  }, true);

  if (document.readyState === 'complete') { wrapPostLink(); }
  else { window.addEventListener('load', wrapPostLink); }
})();
